// extracted by mini-css-extract-plugin
module.exports = {"calendar":"_3jE_bNx","calendar_icon":"XOT-YFN","calendar_month_element":"_3-bXYYD","calendar_select_paper":"_3e8NDtS","calendar_select_root":"_3D214ad"};